export default __webpack_public_path__ + "static/media/knews.74dc4e96.png";